import { Translate } from '@chipinside/translate'
import React from 'react'

import CowmedChip from '#/components/Chip'
import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

const TypeHeatStatus = props => {
  let { status, text, has_reproduction_method_attached, confirmed_as } = props

  if (!status) return null

  const chipConfig = {
    verified: {
      style: Colors.heat.verified,
      type: has_reproduction_method_attached ? 'double-check' : 'check-icon',
      label: text,
    },
    awaiting: {
      style: Colors.heat.awaiting,
      type: 'waiting',
      label: text,
    },
    false: {
      type: 'eye-off',
      label: Translate({ messageKey: 'unseen' }),
      height: 16,
    },
  }

  let chip = chipConfig[status]

  if (confirmed_as === false) {
    chip = chipConfig.false
  }

  const { style, type, label, height } = chip

  const icon = <Icon name={type} size={18} style={{ height: height }} color="currentColor" />

  return <CowmedChip value={label} style={style} width="unset" icon={icon} />
}

export default TypeHeatStatus
